import React from "react";
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row,
  FormText,
} from "reactstrap";

import SelectListComponent from "../utils/selectList";
import DateSelector from "../utils/dateSelector";

const SearchPanel = ({
  airlineValue,
  airlines,
  onSearch,
  startDateChange,
  endDateChange,
  componentErrorMessages,
  handleAirlineChange,
}) => {
  return (
    <Form onSubmit={(e) => e.preventDefault()}>
      <Container>
        <Row>
          <Col xs="6" sm="2">
            <FormGroup className="mb-2">
              <Label>Start Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="startDate" 
                onValueChange={startDateChange}              
                />
              {componentErrorMessages.startDate && (
                <FormText color="danger">
                  {" "}
                  {componentErrorMessages.startDate}
                </FormText>
              )}
            </FormGroup>
          </Col>
          <Col xs="6" sm="2">
            <FormGroup className="mb-2">
              <Label>End Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="endDate" onValueChange={endDateChange}             
                 />
              {componentErrorMessages.endDate && (
                <FormText color="danger">
                  {" "}
                  {componentErrorMessages.endDate}
                </FormText>
              )}
            </FormGroup>
          </Col>
          <Col xs="6" sm="5">
            <FormGroup className="mb-0">
              <Label>Airline</Label>

              <SelectListComponent
                placeholder={"Select Airline..."}
                data={airlines}
                valueKey="Id"
                textField="Name"
                selectValue={airlineValue}
                onValueChange={(payload) => handleAirlineChange(payload)}
              />

              {componentErrorMessages.airlineValue && (
                <FormText color="danger">
                  {" "}
                  {componentErrorMessages.airlineValue}
                </FormText>
              )}
            </FormGroup>
          </Col>

          <Col xs="12" sm="3" md="3" className={"mb-1"}>
            <Button
              className="btn-avi-primary w-100"
              onClick={() => onSearch(1)}
              style={{marginTop:'25px'}}
            >
              Search
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

export default SearchPanel;



// WEBPACK FOOTER //
// ./src/views/flight-operations/flightOperations-panel.js